import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const containerIndex = Loadable(() => import('../containers/index'));
export default MapTo('vcg/components/soe-home/react/whwTech/whwExpressCart')(containerIndex);
